import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import "../../App.css";
import eventIcon from "../../assets/event_home_icons.png";
import "../../styles/events.css"; // Import CSS
import { theme } from '../../styles/theme';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';

const EventSection = ({ title, description, buttonText, buttonAction, backgroundColor }) => {
  return (
    <div className="events-container" style={{ background: backgroundColor, paddingTop: "80px" }}>
      <Grid container justifyContent={'center'} px={5}>
        <Grid size={{ xs: 12, md: 10 }}>
          <Grid container justifyContent={'center'}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <h1 className="events-title">{title}</h1>
            </Grid>
          </Grid>
          <Grid container justifyContent={'center'}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <h4 className="events-description">{description}</h4>
            </Grid>
          </Grid>
          <Grid container justifyContent={'center'}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Button
                variant="contained"
                className="host-button"
                sx={{ background: theme.colors.events.secondary, color: theme.colors.events.black }}
                onClick={buttonAction}
              >
                {buttonText}
              </Button>
            </Grid>
          </Grid>
          <Grid container justifyContent={'center'}>
            <Grid size={{ xs: 12, lg: 6 }} pt={5} container direction={'row-reverse'}>
              <img src={eventIcon} alt="Event Icon" className="event-icon" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

function EventsHomeView() {

  const navigate = useNavigate();

  const location = useLocation();
  const isRoot = location.pathname.includes("/_/events");
  // const isRoot = true;

  const [openDialog, setOpenDialog] = React.useState(false);
  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  return (
    <Box>
      {!isRoot && (
        <>
          {/* <EventSection
            title="Sidewalk is where the best events meet the best vendors! ✨"
            description="Find incredible local events and top-rated vendors all in one place. From pop-ups to food trucks, discover what’s happening around you in real time. Support small businesses, explore unique experiences, and never miss out on what’s trending."
            buttonText="Explore Events"
            buttonAction={handleOpenDialog}
            backgroundColor={theme.colors.events.primary}
          /> */}
          <EventSection
            title="Sidewalk is where your event meets its perfect crowd! 🚀"
            description="Bring your events to life with the power of real-time discovery. Showcase your pop-ups, festivals, and markets to thousands of nearby customers. Grow your brand, connect with vendors, and make every event unforgettable — all on Sidewalk."
            buttonText="Host your event"
            buttonAction={() => navigate("/_/events/manage")}
            backgroundColor={theme.colors.primary}
          />
          <EventSection
            title="Sidewalk connects vendors with the best local events! 🎉"
            description="Join festivals, pop-up markets, and special events where your business shines. Easily discover opportunities, apply to events, and showcase your brand to crowds eager to discover something new. Grow your reach, boost your sales, and be part of unforgettable experiences — all through Sidewalk!"
            buttonText="Apply to events"
            buttonAction={() => navigate("/_/events/manage/2")}
            backgroundColor={theme.colors.secondary}
          />
        </>
      )}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>🚧 Feature Under Construction</DialogTitle>
        <DialogContent>
          Hang tight! We're working on something awesome. This feature is cooking and will be served up soon. 🍳🔥
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
      <Outlet />
    </Box>
  );
}

export default EventsHomeView;